import G from './Getters';
import { nodeEq } from './utils';

function findNode(nodeLocator,nodeList=[]){
  return nodeList.find(node => nodeEq(nodeLocator,node));
}
function whatWouldBeSelectedByClickingThisNode({state,figurePanelId,cell,triggerNodeId:nodeId,selected}){


  let defaultSelection = G.getDefaultSelection(state,{
      figurePanelId,
      cell,
      triggerNodeId:nodeId,
      selected,
    })

  return defaultSelection.map(nodeId => ({cellLocation:cell, nodeId}));

}

export default function nodesThatShouldChange(thisNode, selected, state, figurePanelId){

  let isSelected = findNode(thisNode,selected)

  if( isSelected ){
    return selected;
  }else{

    return whatWouldBeSelectedByClickingThisNode({
      state,
      figurePanelId,
      cell:thisNode.cellLocation,
      triggerNodeId:thisNode.nodeId,
      selected
    })
  }
}
